import type { TProductivityGoalMetric } from 'components/molecules/oneplaform/productivity-goals/types';
import type { TFunction } from 'i18next';

export const createProductivityMetricsMock = (
  t: TFunction,
): TProductivityGoalMetric[] => [
  {
    id: 'efficiency',
    label: t('homeDashboard.productivity.efficiency'),
    percent: 82,
    variant: 'efficiency',
    summaryLabel: t('homeDashboard.productivity.efficiencySummary', {
      current: 156,
      goal: 190,
    }),
    targetLabel: t('homeDashboard.productivity.targetLabel', {
      percent: 85,
    }),
    helperText: t('homeDashboard.productivity.efficiencyHelper', {
      count: 34,
    }),
    helperTone: 'accent',
    targetPercent: 85,
  },
  {
    id: 'effectiveness',
    label: t('homeDashboard.productivity.effectiveness'),
    percent: 76,
    variant: 'effectiveness',
    summaryLabel: t('homeDashboard.productivity.effectivenessSummary', {
      current: 76,
      goal: 100,
    }),
    targetLabel: t('homeDashboard.productivity.targetLabel', {
      percent: 80,
    }),
    helperText: t('homeDashboard.productivity.effectivenessHelper', {
      count: 4,
    }),
    helperTone: 'accent',
    targetPercent: 80,
  },
  {
    id: 'quality',
    label: t('homeDashboard.productivity.quality'),
    percent: 100,
    variant: 'quality',
    summaryLabel: t('homeDashboard.productivity.qualitySummary', {
      current: 32,
      goal: 32,
    }),
    targetLabel: t('homeDashboard.productivity.targetLabel', {
      percent: 95,
    }),
    helperText: t('homeDashboard.productivity.qualityHelper'),
    helperTone: 'positive',
    targetPercent: 95,
  },
];
